const formatedDateCommit = (date: string) => {
  return new Date(date).toLocaleDateString('ru', { day: 'numeric', month: 'short' });
};

export default formatedDateCommit;
